import React from "react";
import "./Info.css";
const Info = () => {
  return (
    <div className="info" style={{ backgroundColor: "#b9f5a0" }}>
      <div className="heading-container">
        <div className="heading-line"></div>
        <span>Day 1</span> 
        <div className="heading">Planting Seeds of Change, Growing a Greener Tomorrow! </div>
      </div>
      <div className="text1">
      On the first day of our Environment Day event, every individual of our institution will take the
initiative to use their air conditioners at 24°C. By adjusting the temperature to an energy-efficient
level, we can collectively save power and contribute to a greener campus. Remember, "Cool and
conscious, together we can make a difference!"
      </div>
      <div className="text2">
      Students and residents of IIITA will advocate for the creation of kitchen gardens and terrace gardens
at home. By growing our own food, we embrace self-sustainability and contribute to a greener world.
Let's nurture the soil and sow the seeds of change, saying, "Home-grown goodness, nature's true
witness!"
      </div>
      <div className="text3">
      At IIIT Allahabad, we deeply value and prioritize sustainable practices. We are delighted to announce
a special recognition event for Amul, Nescafe and GuptaJi Canteen located within our campus. The
event will take place in Admin Block Auditorium and our honourable Director will be present there.
This event aims to celebrate and showcase the efforts of vendors who have actively embraced
sustainable practices within their businesses. Their choice to embrace eco-friendly materials
demonstrates their role in environmental stewardship, setting an inspiring example for others to
follow.

      </div>
      <div className="extra">
        <div className="date">
          <span style={{ fontWeight: "bold" }}>Date</span>: 10 August, 2022
        </div>
        <div className="time">
          <span style={{ fontWeight: "bold" }}>Time</span>: 4:00 PM
        </div>
        <div className="location">
          <span style={{ fontWeight: "bold" }}>Venue</span>: Adminsitrative
          Building
        </div>
      </div>
      <div className="note">
      t. The plantation drive
will commence from our beautiful rock garden located on campus, Symbolising our
commitment to creating a green environment. Following that, we will continue planting at the
director's residence. Remember, "Let's sow the seeds of a greener tomorrow!"
      </div>
    </div>
  );
};

export default Info;
